var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWR(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 9,39 L 36,39 L 36,36 L 9,36 L 9,39 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 12,36 L 12,32 L 33,32 L 33,36 L 12,36 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11,14 L 11,9 L 15,9 L 15,11 L 20,11 L 20,9 L 25,9 L 25,11 L 30,11 L 30,9 L 34,9 L 34,14 L 11,14 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 34,14 L 31,17 L 14,17 L 11,14 L 11,14 Z",
    fill: "#000",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 11,14 L 12,32 L 33,32 L 34,14 L 11,14 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWR);
export default __webpack_public_path__ + "static/media/wR.e3901eb6776726454181e3f45818ea00.svg";
export { ForwardRef as ReactComponent };